<template>
  <!-- 4-n -->
  <q-section v-bind="$attrs" v-if="props.listother.length">
    <q-section v-for="(item, index) in props.listother" :bg-i="item.bg" p="relative" mb="10">
      <DoubleUsers
        :user1="item.user1"
        :user2="item.user2"
        v-bind="item.avatarPosition"
        @avatar-click="handleAvatarClick"
        user-size="44" />
      <q-section v-bind="item.nicknamePosition" class="text-left ellipsis text-nowrap flex flex-col">
        <q-section p="relative" class="text-nowrap ellipsis">{{ item.user1?.nickname }}</q-section>
        <q-section p="relative" class="text-nowrap ellipsis">{{ item.user2?.nickname }}</q-section>
      </q-section>
      <q-section v-bind="item.scorePosition" class="text-center text-nowrap">
        {{ item[item.scoreType] }}
      </q-section>
      <q-section v-bind="item.unitPosition" class="text-center text-nowrap">
        {{ item.unit }}
      </q-section>
      <q-section v-bind="item.rankPosition" class="flex flex-row justify-center items-center">
        {{ index + 4 }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import DoubleUsers from './double-users.vue'
const props = defineProps<{
  listother: any[]
}>()

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
